import React from "react";
import { GET_LIST, Title } from "react-admin";
import { Card, CardContent, Grid, Paper, Button } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import FormControl from "@material-ui/core/FormControl";
import moment from "moment";
import styled from "styled-components";
import {
  isNil,
  prop,
  filter,
  map,
  curry,
  merge,
  propEq,
  reject,
  sortBy,
  range
} from "ramda";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import LinearProgress from "@material-ui/core/LinearProgress";
import Print from "@material-ui/icons/Print";
import Add from "@material-ui/icons/Add";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ReactToPrint from "react-to-print";

const StyleDivWithPrint = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

const GridBordered = styled(Grid)`
  border: 1px solid #000000;
`;

const MonthHeader = styled.div`
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  border-bottom: 1px solid black;
`;
const MonthColumn = styled(Paper)`
  padding: 0.1rem;
`;

class GenericWhiteboard extends React.Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
  }
  async fetchLocations() {
    const dataProvider = await dataProviderFactory("rest");
    const locations = await dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    const baseLocations = filter(location => {
      return isNil(location.base_location_id);
    }, locations.data);

    return baseLocations;
  }

  async fetchData(start, end, city) {
    const dataProvider = await dataProviderFactory("rest");
    const response = await dataProvider(GET_LIST, this.props.resource, {
      filter: merge(
        {
          rental_info: true,
          from: start.format("YYYYMMDD"),
          to: end.format("YYYYMMDD"),
          city: city
        },
        this.props.filter
      ),
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.dateField, order: "asc" }
    });

    return response.data;
  }

  async componentDidMount() {
    const today = moment();
    this.locations = await this.fetchLocations();
    this.currentLocation = "all";
    await this.updateStateForMonth(today, this.currentLocation);
  }

  getTimeInterval = date => ({
    start: date
      .clone()
      .subtract(1, "months")
      .startOf("month"),
    end: date
      .clone()
      .add(2, "months")
      .endOf("month")
  });

  updateStateForMonth = async (month, city) => {
    let selectedCity = null;
    if (city !== "all") {
      selectedCity = city;
    }
    const { start, end } = this.getTimeInterval(month);
    const data = await this.fetchData(start, end, selectedCity);
    this.setState({ month, data, loading: false });
  };

  nextClick = async () => {
    this.setState({ loading: true });
    const month = (this.state.month || moment()).clone().add(1, "months");
    await this.updateStateForMonth(month, this.currentLocation);
  };

  backClick = async () => {
    this.setState({ loading: true });
    const month = (this.state.month || moment()).clone().subtract(1, "months");
    await this.updateStateForMonth(month, this.currentLocation);
  };

  renderCard = data => <this.props.card key={data.id} {...data} />;

  renderMonthColumn = month => {
    const isSameMonth = (dateField, t) =>
      month.isSame(moment(prop(dateField, t)), "month");
    const monthData = filter(
      curry(isSameMonth)(this.props.dateField),
      this.state.data
    );
    return map(this.renderCard, sortBy(prop("tour_start_date"), monthData));
  };

  renderMonthColumnHeader = date => (
    <MonthHeader>{date.format("MMMM")}</MonthHeader>
  );

  handleChange = async event => {
    this.currentLocation = event.target.value;
    this.setState({ loading: true });
    await this.updateStateForMonth(this.state.month, this.currentLocation);
  };

  handleChangeMonth = async event => {
    this.month = event.target.value;
    this.setState({ loading: true });
    this.updateStateForMonth(moment(this.month), this.state.currentLocation);
  };

  render() {
    if (this.state === null || this.state.loading) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    let begining = moment().startOf("month");

    const recordForMonth = month => ({
      id: month.format("YYYY-MM-DD"),
      label: month.format("MMMM YYYY")
    });
    let monthsSelect = map(
      offset => recordForMonth(begining.clone().add(offset, "month")),
      range(-24, 24)
    );

    const cities = map(location => {
      return (
        <MenuItem key={location.id} value={location.id}>
          {location.location_name}
        </MenuItem>
      );
    }, reject(propEq("location_name", "Other"), this.locations));

    const month = this.state.month;
    const months = [
      month.clone().subtract(1, "months"),
      month.clone(),
      month.clone().add(1, "months"),
      month.clone().add(2, "months")
    ];
    return (
      <Card>
        <Button color="primary">
          <a href={this.props.createUrl}>
            <Add />
          </a>
        </Button>
        <Button color="primary" onClick={this.backClick}>
          <ChevronLeft />
        </Button>
        <Button color="primary" onClick={this.nextClick}>
          <ChevronRight />
        </Button>

        <Select
          value={this.currentLocation}
          onChange={this.handleChange}
          inputProps={{
            name: "city",
            id: "city-simple"
          }}
        >
          <MenuItem key={0} value="all">
            All Cities
          </MenuItem>
          {cities}
        </Select>
        <React.Fragment>{ }</React.Fragment>
        <FormControl style={{ paddingLeft: "30px" }}>
          <Select
            value={this.state.month.startOf("month").format("YYYY-MM-DD")}
            onChange={this.handleChangeMonth}
            inputProps={{
              name: "month",
              id: "month-simple"
            }}
          >
            {map(month => {
              return (
                <MenuItem key={month.id} value={month.id}>
                  {month.label}
                </MenuItem>
              );
            }, monthsSelect)}
          </Select>
        </FormControl>
        <ReactToPrint
          trigger={() => (
            <Button color="primary" onClick={this.nextClick} title="Print">
              <Print />
            </Button>
          )}
          content={() => this.componentRef.current}
        />
        <Title title={this.props.title} />
        <CardContent ref={this.componentRef}>
          <StyleDivWithPrint ref={this.componentRef}>
            <Grid container spacing={0}>
              <GridBordered item xs={3} sm={3}>
                <MonthColumn>
                  {this.renderMonthColumnHeader(months[0])}
                  {this.renderMonthColumn(months[0])}
                </MonthColumn>
              </GridBordered>
              <GridBordered item xs={3} sm={3}>
                <MonthColumn>
                  {this.renderMonthColumnHeader(months[1])}
                  {this.renderMonthColumn(months[1])}
                </MonthColumn>
              </GridBordered>
              <GridBordered item xs={3} sm={3}>
                <MonthColumn>
                  {this.renderMonthColumnHeader(months[2])}
                  {this.renderMonthColumn(months[2])}
                </MonthColumn>
              </GridBordered>
              <GridBordered item xs={3} sm={3}>
                <MonthColumn>
                  {this.renderMonthColumnHeader(months[3])}
                  {this.renderMonthColumn(months[3])}
                </MonthColumn>
              </GridBordered>
            </Grid>
          </StyleDivWithPrint>
        </CardContent>
      </Card>
    );
  }
}

export default GenericWhiteboard;



// WEBPACK FOOTER //
// ./src/components/genericWhiteboard.js